import { TmsEventType, } from '../../DataLayer.types';
import { generateDataLayerAvailability } from '../../DataLayerUtils';
import DataLayerBaseEvent from '../DataLayerBaseEvent';
import { generateDataLayerProductList } from './PDPDataLayerUtils';
export default class MatchingAvailabilityEvent extends DataLayerBaseEvent {
    update(tms, payload, errorHandler) {
        const { propertyData, availabilityData, price } = payload;
        const formattedPropertyData = generateDataLayerProductList({
            propertyData,
            price,
            page: 0,
            size: 12,
        });
        const formattedAvailabilityData = generateDataLayerAvailability({
            availabilityData,
        });
        this.updateDataLayer(tms, TmsEventType.link, 'check availability-result', {
            ...formattedAvailabilityData,
            ...formattedPropertyData,
        }, errorHandler);
    }
}
//# sourceMappingURL=MatchingAvailabilityEvent.js.map